import { User } from 'types/user'

export const getUserNameSurname = (user?: User) => {
  return [user?.name, user?.surname].filter(Boolean).join(' ')
}

export const getUserDisplayName = (user?: User) => {
  const nameSurname = getUserNameSurname(user)
  return nameSurname || user?.email || ''
}

export const getUserInitial = (user?: User) => {
  return user?.name?.[0] || user?.email?.[0] || 'U'
}
